export enum EPublicNotificationType {
  UPDATE = 'UPDATE',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  FEATURE = 'FEATURE',
}

export enum EPublicNotificationStatus {
  SCHEDULED = 'SCHEDULED',
  SENDING = 'SENDING',
  SENT = 'SENT',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
}

export interface IPublicNotification {
  id: string;
  type: EPublicNotificationType;
  subject: string;
  body: string;
  status: EPublicNotificationStatus;
  scheduledAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  totalUsers: number | null;
  sentCount: number;
  failedCount: number;
  createdAt: string;
}

export interface IPublicNotificationsResponse {
  data: IPublicNotification[];
  total: number;
}

export interface ICreatePublicNotification {
  type: EPublicNotificationType;
  subject: string;
  body: string;
  scheduledAt?: string;
}
